import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatOptionModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDivider} from "@angular/material/divider";
import {NgForOf, NgIf} from "@angular/common";
import {TranslocoPipe} from "@ngneat/transloco";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {SignatureComponent} from "../../../signature/signature.component";
import {BasicInfoFieldNames} from "../../../basic-info/basic.patient.info.types";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {AcordPacientInformatFieldNames, questions_acord_informat_sib_v2} from "../../acord-pacient-informat.types";
import {DocummentsService} from "../../../documents.service";
import { DocUserField, GeneralFieldNames} from "../../../document-types";
import {ActivatedRoute, Router} from "@angular/router";
import {BasicWizzard} from "../../../base-behaviour/wizzard";
import {getRawVal, getValueOfFieldWithName, iWizzard} from "../../../base-behaviour/base.behaviour.doc.types";
import {FuseAlertComponent} from "../../../../../../@fuse/components/alert";

@Component({
    selector     : 'acord-pacient-informat-sib-v2-wizzard',
    templateUrl  : './acord.pacient.informatsib.v2.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports: [MatIconModule, FormsModule, ReactiveFormsModule, MatStepperModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatCheckboxModule, MatRadioModule, MatDivider, NgIf, TranslocoPipe, MatDatepicker, MatDatepickerInput, MatDatepickerToggle, SignatureComponent, MatSlideToggle, NgForOf, FuseAlertComponent],
})
export class AcordPacientInformatSibV2Wizzard extends BasicWizzard implements OnInit, OnDestroy
{
    formularAcordPacientInf: UntypedFormGroup;
    protected readonly questions = questions_acord_informat_sib_v2;
    descriptionInvParaclinice: string = "-";

    /**
     * Constructor
     */
    constructor(
        private readonly _formBuilder: UntypedFormBuilder,
        _docsService: DocummentsService,
        route: ActivatedRoute,
        router: Router,
        cdrf: ChangeDetectorRef,
    )
    {
        super(_docsService, route, router, cdrf);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Vertical stepper form
        this.formularAcordPacientInf = this._formBuilder.group({
            step1: this._formBuilder.group({
                clinic_act_medical : ['-', Validators.required],
            }),
            step2: this._formBuilder.group({
                info1_4      : [false],
                info2_4      : [false],
                info3_4      : [false],
                info4_4      : [false],
                info5_4      : [false],
                info6_4      : [false],
                info6extra_4 : [''],
                info7_4      : [false],
                info7extra_4 : [''],
                info8_4      : [false],
                info8extra_4 : [''],
                info9_4      : [false],
                info10_4     : [false],
                info11_4     : [false],

                info1_5      : [false],

                info1_6      : [false],
                info2_6      : [false],
                info3_6      : [false],
                info4_6      : [false],

                info1_7      : [false],

                info1_8      : [false],
                // info2_8      : [false],
                // info3_8      : [false],
                // info4_8      : [false],
                // info5_8      : [false],
                // info6_8      : [false],
                // info7_8      : [false],
                // info8_8      : [false],
                // info9_8      : [false],
                // info10_8      : [false],
                // info11_8      : [false],

                info1_9      : [false],
            }),
            step3: this._formBuilder.group({
                acord : [null, Validators.required],
            }),
        });

        this.formularAcordPacientInf.get("step1").get("clinic_act_medical").disable();
        this.init();
    }

    public patchForm(value:DocUserField[]){
        if(!value || value.length == 0) {
            return;
        }

        const descriptionActMedical = getValueOfFieldWithName(value, GeneralFieldNames.clinic_act_medical, this.documentID);
        if (descriptionActMedical) {
            this.formularAcordPacientInf.get('step1').get(GeneralFieldNames.clinic_act_medical).setValue(descriptionActMedical);
        }

        this.descriptionInvParaclinice = getValueOfFieldWithName(value, GeneralFieldNames.clinic_investigatii_paraclinice, this.documentID);


        Object.keys(AcordPacientInformatFieldNames).forEach(key => {
            const fieldKey = key.replace("API_SB_V2__", "");
            const fieldVal = getValueOfFieldWithName(value, key, this.documentID);
            const step: string = "step" + fieldKey.substring(6,7);
            //console.log(`${fieldKey} ${fieldVal} ${step}`);
            if(fieldVal != null) {
                if(this.formularAcordPacientInf.get('step1').get(fieldKey)){
                    this.formularAcordPacientInf.get('step1').get(fieldKey).setValue(getRawVal(fieldVal));
                }
                if(this.formularAcordPacientInf.get('step2').get(fieldKey)){
                    this.formularAcordPacientInf.get('step2').get(fieldKey).setValue(getRawVal(fieldVal));
                }
                //do not patch page 3 with final agreement
                // if(this.formularAcordPacientInf.get('step3').get(fieldKey)){
                //     this.formularAcordPacientInf.get('step3').get(fieldKey).setValue(this.getRawVal(fieldVal));
                // }
            }
        });
        this.cdrf.markForCheck();
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    protected readonly BasicInfoFieldNames = BasicInfoFieldNames;
    protected readonly GeneralFieldNames = GeneralFieldNames;

    protected readonly getValueOfFieldWithName = getValueOfFieldWithName;

    getQuestion(q: string | string) {
        if(q.includes("{REPLACE}")){
            return q.replace("{REPLACE}", this.descriptionInvParaclinice);
        }
        return q;
    }
}
